/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.modals.privateEvent.controllers', [
    'acme.view.application.templates.showTemplatesModal.controllers',
    'acme.view.application.orders.modals.privateEvent.constants',
    'acme.view.application.orders.modals.privateEvent.services',
    'acme.view.application.orders.modals.privateEvent.directive.eventDate',
    'acme.common.directive.dateFieldWithLabel',
    'acme.common.directive.textareaFieldWithLabel',
    'acme.common.service.calendar',
    'acme.common.service.userPreferences',
    'acme.common.service.helpers'
])

.controller('PrivateEventController', [
  '$scope', '$rootScope', '$filter', '$uibModalInstance', '$uibModal', 'ValidateService', 'CalendarService', 'UserPreferencesService', 'HelpersService', '$timeout', 'PrivateEventService', 'ApiService', 'PRIVATE_EVENT_PAYLOAD', 'PRIVATE_EVENT_MODEL', 'PRIVATE_EVENT_EXPIRE_OPTIONS', 'PRIVATE_EVENT_SCHEDULE_TYPE', 'eventId', 'isOrderCheckout', 'accountId', 'accountCategoryRelation',
  function ($scope, $rootScope, $filter, $uibModalInstance, $uibModal, ValidateService, CalendarService, UserPreferencesService, HelpersService, $timeout, PrivateEventService, ApiService, PRIVATE_EVENT_PAYLOAD, PRIVATE_EVENT_MODEL, PRIVATE_EVENT_EXPIRE_OPTIONS, PRIVATE_EVENT_SCHEDULE_TYPE, eventId, isOrderCheckout, accountId, accountCategoryRelation) {
    $scope.privateEventModal = {
        model: angular.copy(PRIVATE_EVENT_MODEL),

        hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
        timesTab: PRIVATE_EVENT_SCHEDULE_TYPE.private.name,
        privateSchedule: false,
        privateScheduleTime: false,
        privateScheduleTimes: [],
        privateDuration: false,

        isLoading: false,
        isSaving: false,
        isSubmitted: false,

        errors: {},

        saveLabel: (!isOrderCheckout) ? 'Add to Cart' : 'Add private event',
        updateLabel: 'Update',
        cancelLabel: 'Cancel',
        eventTemplateComboLabel: 'Event Template',

        expireOptions: angular.copy(PRIVATE_EVENT_EXPIRE_OPTIONS),

        eventTemplates: [],
        priceLists: [],
        discounts: [],

        spectrumConfig: {
            titleText: 'Tile color',
            color: '#d1d1d1'
        },

        organization: false,

        getOrganization: function() {
          var self = this;

          ApiService.partners.detail(accountId).then(function(res) {
            self.organization = res.data.payload.company;
          }, function(response) { });
        },

        getValidators: function() {
            var priceListName = '',
                validators = [];

            if (this.model.priceList) {
                priceListName = this.model.priceList.name;
            }

            validators = [
                {field: 'private-event-date', dateAfterYesterday: {message: 'Invalid date.', test: {value: this.model.date }}},
                {field: 'private-event-duration-hr', greater: {message: ' ', test: {greater: this.model.durationHr, less: -1 }}},
                {field: 'private-event-duration-min', greater: {message: ' ', test: {greater: this.model.durationMin, less: -1 }}},
                {field: 'private-event-name', len: {message: 'A valid event name required.', test: {value: this.model.name, minLength: 2 }}},
                {field: 'private-event-max-capacity', greater: {message: 'Enter a valid max capacity value', test: {greater: this.model.capacity, less: 0 }}},
                {field: 'private-event-price-list', len: {message: 'Please select a price list', test: {value: priceListName }}},
                {field: 'private-event-description', len: {message: 'A valid event description is required', test: {value: this.model.description }}},
                {field: 'private-event-expiration-days', number: {message: 'A valid ticket expire # days is required', test: this.model.expireDays }}
            ];

            if (this.isActiveTab('standard') || !this.hasPrivateSchedulesTimes()) {
              validators.splice(1, 0,
                {field: 'private-event-time-hr', greater: {message: ' ', test: {greater: this.model.timeHr, less: 0 }}},
                {field: 'private-event-time-min', greater: {message: ' ', test: {greater: this.model.timeMin, less: -1 }}}
              );
            }

            return validators;
        },

        isValid: function(field) {
          var r = true,
              text = this.model[field] ? this.model[field].name : '';

          // Check if submitted or bypass validation on command
          if(this.isSubmitted) {
            r = ValidateService.validate([
              {
                len: {
                  value: text
                }
              }
            ]);
          }

          return r;
        },

        changeAMPM: function() {
            $scope.privateEventModal.model.timeAm = !$scope.privateEventModal.model.timeAm;
        },

        cancel: function() {
            $uibModalInstance.dismiss();
        },

        isActiveTab: function(type) {
          return (type === this.timesTab);
        },

        setTab: function(type) {
          this.timesTab = type;
        },

        setPrivateScheduleTimes: function() {
          var self = $scope.privateEventModal;

          if (this.hasPrivateSchedulesTimes()) {
            this.privateScheduleTimes = this.privateSchedule.hours.map(function(opening) {
              var date = new Date();

              date.setHours(opening.hour);
              date.setMinutes(opening.minutes);
              date.setSeconds(0);
              date.setMilliseconds(0);

              opening.id = date;
              opening.name = $filter('date')(CalendarService.parseDate(date), self.hourFormat);
              opening.date = date;

              return opening;
            });

            if (this.privateScheduleTimes.length) {
              this.privateScheduleTime = this.privateScheduleTimes[0];
            }
          }
        },

        hasPrivateSchedulesTimes: function () {
          return (this.privateSchedule.hasOwnProperty('hours') && this.privateSchedule.hours.length);
        },

        resetPrivateSchedule: function() {
          var self = $scope.privateEventModal;

          self.privateSchedule = false;
          self.privateScheduleTimes = [];
          self.privateScheduleTime = false;
          self.privateDuration = false;
        },

        checkDuration: function() {
          return (
            Number(this.model.durationHr) !== this.privateDuration.hour ||
            Number(this.model.durationMin) !== this.privateDuration.minutes
          );
        },

        undoDuration: function() {
          var duration = angular.copy(this.privateDuration);

          this.model.durationHr = (duration.hour || (!duration.hour && duration.minutes)) ? duration.hour : 1;
          this.model.durationMin = duration.minutes || 0;
        },

        setModelFromTemplate: function(template) {
            var self = $scope.privateEventModal,
                schedules = template.schedules || [],
                schedule = schedules[0] || {},
                days = schedule.days || [],
                startTime = template.startTime || new Date().getTime(),
                date = new Date(startTime),
                duration = schedule.duration || {},
                hours = schedule.hours || [],
                hoursMinutes = hours[0] || {},
                hour = hoursMinutes.hour || 0,
                ticketDetails = template.ticketDetails || {},
                priceLists = template.priceLists || [],
                priceList = priceLists[0] || template.priceList || {},
                model = self.model;

            self.resetPrivateSchedule();

            model.templateId = template.id;

            model.name = template.name;
            model.description = template.description;
            model.shortDescription = template.shortDescription;
            model.emailConfirmationMessage = template.emailConfirmationMessage;
            model.emailCancellationMessage = template.emailCancellationMessage;
            model.addOns = template.addOns;

            if (template.colorCategory) {
                model.colorCategory = template.colorCategory;
                self.spectrumConfig.color = template.colorCategory.backgroundColor;
            }

            if (template.customFields) {
              model.customFields = template.customFields;
            }

            if (template.GLCode) {
                model.GLCode = template.GLCode;
            }

            if (template.emailNotify) {
                model.emailNotify = template.emailNotify;
            }

            if (template.onlinePaymentsForOrgOrdersEmailNotify) {
                model.onlinePaymentsForOrgOrdersEmailNotify = template.onlinePaymentsForOrgOrdersEmailNotify;
            }

            if (schedules.length) {
              schedules.forEach(function(item) {
                if (item.type === PRIVATE_EVENT_SCHEDULE_TYPE.private.name) {
                  self.privateSchedule = item;

                  self.model.durationHr = (item.duration.hour || (!item.duration.hour && item.duration.minutes)) ? item.duration.hour : 1;
                  self.model.durationMin = item.duration.minutes || 0;
                  self.model.capacity = item.capacity;
                  self.model.scheduleName = item.name;

                  self.privateDuration = angular.copy(item.duration);

                  self.setPrivateScheduleTimes();
                }
              });
            }

            if (eventId) { //Update
                model.expireDays = ticketDetails.ticketDurationDays;
                model.expireOption = $scope.privateEventModal.expireOptions[ticketDetails.expireFromEventDate ? 0 : 1];

                model.date = new Date(template.startTime);

                model.durationHr = (duration.hour || (!duration.hour && duration.minutes)) ? duration.hour : 1;
                model.durationMin = duration.minutes || 0;


                model.timeHr = date.getHours() % 12;
                if (model.timeHr === 0) {
                    model.timeHr = 12; // 0 hour == 12AM
                }
                model.timeMin = date.getMinutes();
                model.timeAm = date.getHours() < 12;

                model.capacity = schedule.capacity || template.capacity;

                model.scheduleName = schedule.name;
            }

            model.priceList = priceList;
            $scope.privateEventModal.priceLists.forEach(function(item){
                if (item.id === priceList.id || item.id === priceList.priceListId) {
                    model.priceList = item;
                }
            });
        },

        processResourceRequests: function(requests) {
          var r = false;

          if (requests instanceof Array) {
            r = requests.map(function(item) {
              return item.eventResource;
            });
          }

          return r;
        },

        generatePayload: function() {
            var self = this,
                model = this.model,
                d = moment(model.date),
                timeAm = model.timeAm ? 'AM' : 'PM',
                isPrivateSchedule = (self.privateSchedule && self.isActiveTab('private') && self.privateScheduleTime),
                militaryTime = (isPrivateSchedule) ? moment().hour(self.privateScheduleTime.hour).minute(self.privateScheduleTime.minutes).second(0).format('HH:mm:ss') : moment(model.timeHr + ':' + model.timeMin + ':00 ' + timeAm, 'h:mm:ss A').format('HH:mm:ss'),
                dateTime = moment(d.format('YYYY-MM-DD') + 'T' + militaryTime),
                payload = angular.copy(PRIVATE_EVENT_PAYLOAD),
                schedule = payload.schedules[0];

            schedule.days = [dateTime.format('YYYY-MM-DD')];

            schedule.effectiveStartTime = dateTime.format('YYYY-MM-DDTHH:mm:ssZZ');

            if (isPrivateSchedule) {
              schedule.hours = [self.privateScheduleTime];
            } else {
              schedule.hours = [{
                  hour: parseInt(dateTime.format('HH'), 10),
                  minutes: parseInt(dateTime.format('mm'), 10),
                  quantity: 1
              }];
            }

            schedule.resourceRequest = (self.privateSchedule && self.privateSchedule.resourceRequests && self.privateSchedule.resourceRequests.length) ? self.privateSchedule.resourceRequests : [];

            schedule.capacity = model.capacity;

            schedule.duration = {
                hour: model.durationHr,
                minutes: model.durationMin
            };

            schedule.name = model.scheduleName;

            if (model.addOns) {
                payload.addOns = model.addOns;
            }

            payload.id = (model.eventTemplate && model.eventTemplate.id) ? model.eventTemplate.id : false;

            if (isPrivateSchedule) {
              payload.scheduleId = self.privateSchedule.id;
              
              payload.salesChannels = self.privateSchedule.salesChannels.map(function(item) {
                if (item.name.toLowerCase() === 'web') {
                  item.enabled = false;
                }
                return item;
              });
            }

            if (accountId) {
              payload.organization = self.organization;
            }

            payload.capacity = model.capacity;

            payload.priceLists = [model.priceList];

            payload.startTime = schedule.effectiveStartTime;

            payload.endTime = moment(payload.startTime).add(model.durationHr, 'hours').add(model.durationMin, 'minutes').format();

            payload.discountId = (model.discount && model.discount.id) ? model.discount.id : '';

            payload.name = model.name;

            payload.description = HelpersService.strip(model.description, 300) || model.shortDescription;
            payload.shortDescription = model.shortDescription;

            payload.ticketDetails.expireFromEventDate = model.expireOption === self.expireOptions[0];
            payload.ticketDetails.ticketDurationDays = model.expireDays;

            payload.emailConfirmationMessage = model.emailConfirmationMessage;
            payload.emailCancellationMessage = model.emailCancellationMessage;

            payload.colorCategory = model.colorCategory;

            payload.GLCode = model.GLCode;
            payload.emailNotify = model.emailNotify;
            payload.onlinePaymentsForOrgOrdersEmailNotify = model.onlinePaymentsForOrgOrdersEmailNotify;

            if (model.customFields) {
              payload.customFields = model.customFields;
            }

            return payload;
        },

        save: function() {
            var self = this;

            self.isSubmitted = true;

            if (!ValidateService.validate(this.getValidators())) {
                this.errors = ValidateService.getErrorHash();
                return;
            }

            self.isSaving = true;
            self.isSubmitted = false;

            if (isOrderCheckout) {
              self.saveForOrderCheckout();
            } else {
              self.saveForCartCheckout();
            }
        },

        saveForOrderCheckout: function(){
          var self = this,
              accountId = self.accountId || false,
              accountCategoryRelation = self.accountCategoryRelation || false;

          PrivateEventService.addToOrderCheckout(self.generatePayload(), accountId, accountCategoryRelation).then(function(res) {
            $uibModalInstance.close(res);
          }).finally(function(res) {
              self.isSaving = false;
          });
        },

        saveForCartCheckout: function() {
          var self = this;

          if (eventId) { // UPDATE AN EVENT
              var template = self.generatePayload();
              template.id = self.template.id;
              PrivateEventService.updateEventAndTemplate(self.model, self.event, template).then(function() {
                  $uibModalInstance.dismiss();
                  $rootScope.$broadcast('Cart::Open');
                  $rootScope.$broadcast('Cart::Refresh');
              }).finally(function(res) {
                  self.isSaving = false;
              });
          } else { // CREATE A NEW EVENT
              PrivateEventService.addToCart(self.generatePayload()).then(function() {
                  $uibModalInstance.dismiss();
                  $scope.$emit('Cart::Open');
              }).finally(function() {
                  self.isSaving = false;
              });
          }
        },

        searchTemplates: function(search) {
            PrivateEventService.getTemplateNames(false, search).then(function(res) {
                $scope.privateEventModal.eventTemplates = res.data.payload.list;
                $scope.$broadcast('CustomTypeahead::FilterResults', {field: 'combobox-input-' + 'event-templates'});
            });
        },

        onTemplateChange: function() {
            var self = this,
                template = self.model.eventTemplate;
            if (template) {
                PrivateEventService.getTemplate(template.id).then(function(res) {
                    self.setModelFromTemplate(res.data.payload);
                });
                PrivateEventService.getEventTemplateDetail(template.id).then(function(res){
                    var payload = res.data.payload || [],
                        templateDetail = payload[0] || {},
                        discountId = templateDetail.discountId,
                        discounts = self.discounts || [];
                    discounts.forEach( function (discount) {
                        if (discount.id === discountId) {
                            self.model.discount = discount;
                        }
                    });

                    if (self.model.discount && self.model.discount.id && self.model.priceList && self.model.priceList.id) {
                      PrivateEventService.getEventTemplateDiscountedPriceList(self.model.discount.id, self.model.priceList.id).then(function(res) {
                        var discountedPriceList = res.data.payload.prices || [];
                        if (discountedPriceList.length) {
                          self.model.priceList.prices = discountedPriceList;
                        }
                      });
                    }
                });
            } else { // Clear all the fields
                this.model = angular.copy(PRIVATE_EVENT_MODEL);
                this.spectrumConfig.color = this.model.colorCategory.backgroundColor;

                this.resetPrivateSchedule();
            }
        },

        tryClearErrors: function() {
            var self = this;
            if (Object.keys(self.errors).length === 0) {
                return;
            }
            $timeout.cancel($scope.validateTimer);
            $scope.validateTimer = $timeout(function() {
                ValidateService.validate(self.getValidators());
                self.errors = ValidateService.getErrorHash();
            }, 2000);
        },

        init: function() {
            var self = this;

            if (accountId) {
              self.accountId = accountId;

              self.getOrganization();
            }

            if (accountCategoryRelation) {
              self.accountCategoryRelation = accountCategoryRelation;
            }

            if (eventId) {//Update an existing event
                PrivateEventService.getEventInstance(eventId).then(function(res) {
                    self.event = res.event;
                    self.template = res.template;

                    self.eventTemplateComboLabel = self.event.name;

                    self.setModelFromTemplate(self.event);
                });
                $scope.privateEventModal.saveLabel = $scope.privateEventModal.updateLabel;


            } else { // Create a new event

                PrivateEventService.getPriceLists().then(function(res) {
                    self.priceLists = res.data.payload.list;
                });
                PrivateEventService.getDiscounts().then(function(res) {
                    self.discounts = res.data.payload.list;
                });
                PrivateEventService.getTemplateNames(false).then(function(res) {
                    self.eventTemplates = res.data.payload.list;
                });
            }

            $scope.$watchGroup(['privateEventModal.model.name','privateEventModal.model.date','privateEventModal.model.capacity','privateEventModal.model.priceList','privateEventModal.model.description','privateEventModal.model.timeMin','privateEventModal.model.durationMin'], function() {
                self.tryClearErrors();
            });

            $scope.$watch('privateEventModal.model.timeHr', function(newVal, oldVal) {
               if (newVal !== null && self.model.timeMin === null) {
                   self.model.timeMin = '00';
               }
                self.tryClearErrors();
            });

            $scope.$watch('privateEventModal.model.durationHr', function(newVal, oldVal) {
                if (newVal !== null && self.model.durationMin === null) {
                    self.model.durationMin = '00';
                }
                self.tryClearErrors();
            });

        }
    };

    $.cachedScript( "/assets/spectrum.min.js" );
    $.loadCss( "/assets/spectrum.min.css", 'spectrum', function() {});

    $scope.privateEventModal.init();

}]);